import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import { Pagination } from '../../../model/paginatiion';
import { IAuditResponse } from '../../../model/base/response/audit-response';

interface AuditsState {
  audits: Pagination<IAuditResponse>;
  loading: boolean;
  error: string | null;
}

type AuditsAction =
  | { type: 'LOAD_START' }
  | { type: 'LOAD_SUCCESS'; payload: Pagination<IAuditResponse> }
  | { type: 'LOAD_ERROR'; payload: string };

const initialState: AuditsState = {
  audits: new Pagination<IAuditResponse>([], 1, 0, 10, 0),
  loading: false,
  error: null,
};

const AuditsStateContext = createContext<AuditsState | undefined>(undefined);
const AuditsDispatchContext = createContext<React.Dispatch<AuditsAction> | undefined>(undefined);

function auditsReducer(state: AuditsState, action: AuditsAction): AuditsState {
  switch (action.type) {
    case 'LOAD_START':
      return { ...state, loading: true, error: null };
    case 'LOAD_SUCCESS':
      return { ...state, loading: false, audits: action.payload };
    case 'LOAD_ERROR':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export function AuditsProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(auditsReducer, initialState);

  return (
    <AuditsStateContext.Provider value={state}>
      <AuditsDispatchContext.Provider value={dispatch}>
        {children}
      </AuditsDispatchContext.Provider>
    </AuditsStateContext.Provider>
  );
}

export function useAuditsState() {
  const context = useContext(AuditsStateContext);
  if (context === undefined) {
    throw new Error('useAuditsState must be used within AuditsProvider');
  }
  return context;
}

export function useAuditsDispatch() {
  const context = useContext(AuditsDispatchContext);
  if (context === undefined) {
    throw new Error('useAuditsDispatch must be used within AuditsProvider');
  }
  return context;
}
